const researchFocus = [
  {
    image: `${process.env.PUBLIC_URL}/pervasive.png`,
    title: "Persuasive Technologies",
    description:
      "Exploring technologies seamlessly integrated into everyday environments to enhance human-computer interaction.",
  },
  {
    image: `${process.env.PUBLIC_URL}/llms.png`,
    title: "Large Language Models",
    description:
      "Advancing natural language processing with state-of-the-art models for understanding and generating human-like text.",
  },
  {
    image: `${process.env.PUBLIC_URL}/asr.png`,
    title: "Speech Recognition",
    description:
      "Innovating voice processing systems to enable accurate and natural interactions with spoken language.",
  },
  {
    image: `${process.env.PUBLIC_URL}/science.png`,
    title: "AI for Health",
    description:
      "Harnessing artificial intelligence to improve healthcare outcomes, diagnostics, and patient care systems.",
  },
  {
    image: `${process.env.PUBLIC_URL}/ar.png`,
    title: "Augmented Reality",
    description:
      "Developing immersive solutions that blend digital elements with the real world to enhance user experiences.",
  },
  {
    image: `${process.env.PUBLIC_URL}/vr.jpg`,
    title: "Virtual Reality",
    description:
      "Creating fully immersive environments for simulation, training, and interactive learning experiences.",
  },
];

export default researchFocus;
